import { Capacitor } from '@capacitor/core';

/**
 * `true` SOMENTE quando o player roda num navegador **desktop**
 * (Windows/macOS/Linux) — NUNCA numa Smart TV (Tizen/webOS) nem em mobile
 * (Android/iOS).
 *
 * ⚠️ FONTE ÚNICA (não duplicar). Antes existiam DUAS cópias divergentes desta
 * lógica: o `VolumeService` foi corrigido em 2026-06-06 pra excluir Smart TV,
 * mas o `ConfigManager` tinha a própria cópia SEM esse fix → a UA da Tizen
 * ("...SMART-TV; LINUX; Tizen 9.0...") batia em `/Linux/`, era classificada como
 * desktop e o ConfigManager setava `disableVolume=true`, matando o `setVolume`
 * e o watchdog de reset na TV (volume da config nunca chegava no hardware).
 * Unificado aqui pra não regredir de novo.
 */
export function isDesktopBrowser(): boolean {
  // Capacitor native (Android) nunca é desktop browser.
  if (Capacitor.getPlatform() !== 'web') return false;

  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';

  // Smart TVs primeiro: Tizen 9.0 tem UA "...LINUX; Tizen 9.0..." que casaria
  // com o /Linux/ do check de desktop abaixo. Excluir explicitamente.
  if (/SMART-TV|Tizen|Web0S|webOS/i.test(ua)) return false;

  const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);
  const isDesktop = /Macintosh|MacIntel|Windows|Linux/i.test(ua);
  return isDesktop && !isMobile;
}
